module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-sgbrideonthehunt-sm-436bf1e219cbf3d54a9c8405e61e93d5.png";